// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @14.07.2017 13:53:29
import { CEventHistory_abstract } from './../../abstract/SagaSchema/History/CEventHistory_abstract';
export class CEventHistory extends CEventHistory_abstract {}
